import { legalEn, legalEs, legalPt } from 'src/i18n/legal';
import { roadmapItemsEn, roadmapItemsEs, roadmapItemsPt } from 'src/i18n/roadmapItems';
import { morePages } from 'src/i18n/morePages';
import { shellPages } from 'src/i18n/shellPages';

const plansPt = {
  free: {
    name: 'Free',
    description: 'Acesso básico permanente após o trial de 20 dias',
    features: [
      '1 clínica',
      '1 profissional',
      'Agenda e calendário',
      'Paciente: visão geral + mídias',
      'Odontograma, HOF e Sugestões com cadeado',
      '100 MB de espaço'
    ]
  },
  individual: {
    name: 'Individual',
    description: 'Para o dentista que atende sozinho',
    features: [
      '1 clínica',
      '1 profissional',
      '500 MB de espaço',
      'Agenda, confirmação por link e lembrete por e-mail',
      'Odontograma + mapa HOF',
      'Anexos de mídia',
      'Sugestões da plataforma',
      'Suporte por e-mail'
    ]
  },
  essencial: {
    name: 'Essencial',
    description: 'Para consultórios começando a digitalizar',
    features: [
      '1 clínica',
      'Até 2 secretárias',
      'Até 5 profissionais',
      'Agenda, confirmação por link e lembrete por e-mail',
      'Odontograma + mapa HOF',
      'Anexos de mídia (2 GB)',
      'Compressão de imagem/vídeo 50–70%',
      'Suporte por e-mail'
    ]
  },
  clinica: {
    name: 'Clínica',
    description: 'Para equipes com uma ou duas unidades',
    features: [
      'Até 2 clínicas',
      'Até 6 secretárias',
      'Até 20 profissionais',
      'Tudo do Essencial',
      'Anexos de mídia (6 GB · 3 GB/clínica)',
      'Compressão de imagem/vídeo 30–40%',
      'Suporte prioritário'
    ]
  },
  rede: {
    name: 'Rede',
    description: 'Para grupos e múltiplas unidades',
    features: [
      'Até 10 clínicas',
      'Secretárias ilimitadas',
      'Profissionais ilimitados',
      'Switcher multi-clínica + onboarding',
      'Anexos de mídia (50 GB · 5 GB/clínica)',
      'Compressão de imagem/vídeo 10–20%',
      'Prioridade de roadmap'
    ]
  }
};

const plansEn = {
  free: {
    name: 'Free',
    description: 'Basic access after the 20-day trial',
    features: [
      '1 clinic',
      '1 professional',
      'Schedule and calendar',
      'Patient: overview + media',
      'Odontogram, HOF and Suggestions locked',
      '100 MB of storage'
    ]
  },
  individual: {
    name: 'Individual',
    description: 'For a dentist practicing solo',
    features: [
      '1 clinic',
      '1 professional',
      '500 MB of storage',
      'Schedule, confirmation link and email reminders',
      'Odontogram + HOF map',
      'Media attachments',
      'Platform suggestions',
      'Email support'
    ]
  },
  essencial: {
    name: 'Essential',
    description: 'For practices starting to go digital',
    features: [
      '1 clinic',
      'Up to 2 secretaries',
      'Up to 5 professionals',
      'Schedule, confirmation link and email reminders',
      'Odontogram + HOF map',
      'Media attachments (2 GB)',
      'Image/video compression 50–70%',
      'Email support'
    ]
  },
  clinica: {
    name: 'Clinic',
    description: 'For teams with one or two locations',
    features: [
      'Up to 2 clinics',
      'Up to 6 secretaries',
      'Up to 20 professionals',
      'Everything in Essential',
      'Media attachments (6 GB · 3 GB/clinic)',
      'Image/video compression 30–40%',
      'Priority support'
    ]
  },
  rede: {
    name: 'Network',
    description: 'For groups and multiple locations',
    features: [
      'Up to 10 clinics',
      'Unlimited secretaries',
      'Unlimited professionals',
      'Multi-clinic switcher + onboarding',
      'Media attachments (50 GB · 5 GB/clinic)',
      'Image/video compression 10–20%',
      'Roadmap priority'
    ]
  }
};

const plansEs = {
  free: {
    name: 'Free',
    description: 'Acceso básico permanente después de la prueba de 20 días',
    features: [
      '1 clínica',
      '1 profesional',
      'Agenda y calendario',
      'Paciente: visión general + medios',
      'Odontograma, HOF y Sugerencias con candado',
      '100 MB de espacio'
    ]
  },
  individual: {
    name: 'Individual',
    description: 'Para el dentista que atiende solo',
    features: [
      '1 clínica',
      '1 profesional',
      '500 MB de espacio',
      'Agenda, confirmación por enlace y recordatorio por e-mail',
      'Odontograma + mapa HOF',
      'Adjuntos de medios',
      'Sugerencias de la plataforma',
      'Soporte por correo'
    ]
  },
  essencial: {
    name: 'Esencial',
    description: 'Para consultorios que empiezan a digitalizarse',
    features: [
      '1 clínica',
      'Hasta 2 secretarias',
      'Hasta 5 profesionales',
      'Agenda, confirmación por enlace y recordatorio por e-mail',
      'Odontograma + mapa HOF',
      'Adjuntos de medios (2 GB)',
      'Compresión de imagen/video 50–70%',
      'Soporte por correo'
    ]
  },
  clinica: {
    name: 'Clínica',
    description: 'Para equipos con una o dos sedes',
    features: [
      'Hasta 2 clínicas',
      'Hasta 6 secretarias',
      'Hasta 20 profesionales',
      'Todo lo de Esencial',
      'Adjuntos de medios (6 GB · 3 GB/clínica)',
      'Compresión de imagen/video 30–40%',
      'Soporte prioritario'
    ]
  },
  rede: {
    name: 'Red',
    description: 'Para grupos y varias sedes',
    features: [
      'Hasta 10 clínicas',
      'Secretarias ilimitadas',
      'Profesionales ilimitados',
      'Cambio multi-clínica + onboarding',
      'Adjuntos de medios (50 GB · 5 GB/clínica)',
      'Compresión de imagen/video 10–20%',
      'Prioridad en el roadmap'
    ]
  }
};

export const dictionaries = {
  'pt-BR': {
    plans: plansPt,
    roles: {
      admin: 'Admin',
      secretary: 'Secretária',
      professional: 'Profissional',
      super_admin: 'Super admin'
    },
    nav: {
      dashboard: 'Dashboard',
      appointments: 'Agendamentos',
      patients: 'Pacientes',
      myCalendar: 'Meu Calendário',
      generalCalendar: 'Calendário Geral',
      users: 'Usuários',
      settings: 'Configurações',
      clinics: 'Gerenciar Clínicas',
      logout: 'Sair',
      openSidebar: 'Abrir sidebar',
      superAdmin: 'Modo Super Admin',
      fullAccess: 'Acesso completo ao sistema',
      setupTitle: 'Configuração Necessária',
      setupBody: 'Você precisa configurar sua clínica para continuar.',
      setupCta: 'Configurar Agora'
    },
    news: {
      title: 'Novidades',
      subtitle: 'Chamados da sua clínica, roadmap e sugestões da plataforma.',
      open: 'Novidades',
      unread: 'Há resposta nova do suporte',
      back: 'Voltar',
      cancel: 'Cancelar',
      tabs: {
        support: 'Chamados',
        roadmap: 'Roadmap',
        suggestions: 'Sugestões'
      },
      errors: {
        generic: 'Não foi possível concluir. Tente de novo.',
        'file-too-big': 'Arquivo acima de 15 MB.',
        'file-type': 'Use imagem, PDF ou MP4.',
        'too-many-files': 'No máximo 4 arquivos.',
        'empty-message': 'Escreva uma mensagem ou anexe um arquivo.',
        'subject-required': 'Informe o assunto.',
        'title-required': 'Informe o título.',
        'body-required': 'Descreva a sugestão.',
        'missing-clinic': 'Selecione uma clínica para abrir o chamado.',
        'missing-ticket': 'Chamado não encontrado.'
      },
      support: {
        new: 'Novo chamado',
        subject: 'Assunto',
        message: 'Mensagem',
        send: 'Enviar',
        reply: 'Responder',
        attach: 'Anexar imagem, PDF ou vídeo',
        removeFile: 'Remover arquivo',
        empty: 'Nenhum chamado ainda.',
        emptyHint: 'Abra um chamado para falar com o suporte. Só a sua clínica vê essa conversa.',
        select: 'Selecione um chamado para ver a conversa.',
        search: 'Buscar chamados...',
        statusFilter: 'Status:',
        endOfList: 'Sem mais chamados para exibir',
        olderMessages: 'Carregar mensagens anteriores',
        noResults: 'Nenhum chamado encontrado.',
        noResultsHint: 'Tente outro status ou ajuste a busca.',
        customerLabel: 'Cliente',
        supportTeam: 'Equipe AgilOdonto',
        replyPlaceholder: 'Escreva sua resposta...',
        messagePlaceholder: 'Descreva o que está acontecendo...',
        supportLabel: 'Suporte',
        changeStatus: 'Alterar status',
        created: 'Chamado aberto.',
        sent: 'Mensagem enviada.',
        statusUpdated: 'Status atualizado.',
        loadError: 'Não foi possível carregar os chamados.',
        status: {
          all: 'Todos',
          open: 'Aberto',
          in_progress: 'Em andamento',
          waiting_customer: 'Aguardando você',
          waiting_customer_admin: 'Aguardando cliente',
          resolved: 'Resolvido'
        }
      },
      roadmap: {
        items: roadmapItemsPt,
        empty: 'Nada publicado no roadmap ainda.',
        emptyHint: 'Os próximos passos da plataforma aparecem aqui.',
        new: 'Novo item',
        edit: 'Editar',
        titleField: 'Título',
        description: 'Descrição',
        statusLabel: 'Status',
        save: 'Publicar',
        update: 'Salvar',
        archive: 'Arquivar',
        unarchive: 'Restaurar',
        showArchived: 'Mostrar arquivados',
        archived: 'Arquivado',
        moveUp: 'Mover para cima',
        moveDown: 'Mover para baixo',
        delete: 'Excluir',
        confirmDelete: 'Excluir este item do roadmap?',
        created: 'Item publicado.',
        saved: 'Roadmap atualizado.',
        loadError: 'Não foi possível carregar o roadmap.',
        status: {
          planned: 'Planejado',
          in_progress: 'Em andamento',
          done: 'Concluído'
        }
      },
      suggestions: {
        empty: 'Nenhuma sugestão ainda.',
        emptyHint: 'Conte o que melhoraria a plataforma.',
        new: 'Nova sugestão',
        titleField: 'Título',
        body: 'Descrição',
        publish: 'Publicar',
        likes: '{count} curtidas',
        comments: '{count} comentários',
        commentPlaceholder: 'Escreva um comentário',
        send: 'Enviar',
        noComments: 'Nenhum comentário ainda.',
        by: 'por {name}',
        changeStatus: 'Status da sugestão',
        remove: 'Remover',
        confirmDelete: 'Remover esta sugestão e os comentários?',
        created: 'Sugestão publicada.',
        commented: 'Comentário enviado.',
        loadError: 'Não foi possível carregar as sugestões.',
        status: {
          open: 'Aberta',
          planned: 'Planejada',
          done: 'Feita',
          declined: 'Recusada'
        }
      }
    },
    tester: {
      banner: 'Conta de teste — acesso livre à plataforma, sem assinatura.',
      badge: 'Conta teste',
      toggle: 'Conta de teste',
      toggleHint: 'Acesso livre, sem cobrança. O banner fica visível para toda a equipe.'
    },
    trial: {
      endsIn: 'Seu período de teste termina em {count} dias. Assine agora e não perca seus dados.',
      endsInOne: 'Seu período de teste termina em 1 dia. Assine agora e não perca seus dados.',
      ended: 'Seu trial de 20 dias terminou. Você está no Plano Free: Agenda, Calendário e Paciente (Visão geral + Mídias). Demais recursos ficam visíveis com cadeado.',
      cta: 'Assinar Agora'
    },
    upgrade: {
      title: 'Desbloqueie recursos do consultório',
      body: 'No Free você mantém Agenda, Calendário e Paciente (Visão geral + Mídias). Faça upgrade para Odontograma, HOF, Sugestões e o restante do prontuário.',
      benefitOdontogram: 'Odontograma e mapa HOF',
      benefitTabs: 'Todas as abas do paciente',
      benefitSuggestions: 'Sugestões (NewsHub)',
      benefitLimits: 'Limites do plano Individual (1 clínica · 1 profissional)',
      freeName: 'Free',
      freePrice: 'R$ 0',
      freePointSeats: '· 1 clínica · 1 prof.',
      freePointAgenda: '· Agenda + Calendário',
      freePointPatient: '· Paciente: visão + mídias',
      freePointLocks: '· Demais com cadeado',
      paidName: 'Individual',
      paidPrice: 'R$ 15/mês',
      paidPointSeats: '· 1 clínica · 1 prof.',
      paidPointClinical: '· Odontograma + HOF',
      paidPointSuggestions: '· Sugestões + abas full',
      paidPointStorage: '· 500 MB de mídia',
      cta: 'Fazer upgrade',
      stayFree: 'Continuar no grátis',
      orStayFree: 'ou Continuar no grátis',
      seePlans: 'Ver planos',
      askAdmin: 'Peça ao admin da clínica para assinar o Individual.',
      close: 'Fechar',
      cardTitle: 'Desbloqueie o consultório completo',
      cardPrice: 'Individual a partir de R$15/mês',
      afterTrialBadge: 'Após trial · Free ativo',
      suggestionsTitle: 'Sugestões é pago',
      suggestionsBody: 'No Plano Free este módulo fica bloqueado. Faça upgrade para o Individual (R$15/mês) ou superior e continue de onde parou.',
      patientTabLocked: {
        odontograma: 'No Plano Free o odontograma fica bloqueado. Faça upgrade para registrar o histórico dentário deste paciente.',
        hof: 'No Plano Free o mapa HOF fica bloqueado. Faça upgrade para marcar regiões, procedimentos e o antes e depois.',
        ortodontia: 'No Plano Free a ortodontia fica bloqueada. Faça upgrade para acompanhar o tratamento deste paciente.',
        default: 'Esta parte do prontuário fica bloqueada no Plano Free. Faça upgrade para continuar.'
      }
    },
    weekdays: {
      sunday: 'Domingo',
      monday: 'Segunda',
      tuesday: 'Terça',
      wednesday: 'Quarta',
      thursday: 'Quinta',
      friday: 'Sexta',
      saturday: 'Sábado'
    },
    hours: {
      title: 'Horários de atendimento',
      hint: 'Define a grade disponível na agenda',
      until: 'até',
      break: 'Intervalo',
      to: 'às'
    },
    dashboard: {
      title: 'Dashboard',
      myTitle: 'Meu Dashboard',
      subtitle: 'Visão geral da clínica',
      mySubtitle: 'Visão geral dos seus agendamentos',
      date: 'Data:',
      today: 'Ver Hoje',
      all: 'Ver Todos',
      total: 'Total de Agendamentos',
      mine: 'Meus Agendamentos',
      confirmed: 'Confirmados',
      pending: 'Pendentes',
      cancelled: 'Cancelados',
      noShow: 'Faltaram',
      appointmentsOf: 'Agendamentos de {date}',
      myAppointments: 'Meus Agendamentos',
      allSuffix: ' - Todos',
      emptyToday: 'Nenhum agendamento para hoje',
      emptyMine: 'Nenhum agendamento seu para hoje',
      emptyAll: 'Nenhum agendamento encontrado',
      noClinicTitle: 'Nenhuma Clínica Selecionada',
      noClinicBody: 'Selecione uma clínica para continuar.',
      loadError: 'Erro ao carregar dados do dashboard',
      needClinic: 'Você precisa configurar sua clínica primeiro',
      professional: 'Profissional',
      statusConfirmed: 'Confirmado',
      statusPending: 'Pendente',
      statusCancelled: 'Cancelado',
      statusNoShow: 'Faltou',
      statusCompleted: 'Concluído',
      professionals: 'Profissionais Ativos',
      adminSuffix: '(Admin)'
    },
    pending: {
      title: 'Confirmações pendentes',
      onTrack: 'Em dia',
      empty: 'Nenhum agendamento futuro aguardando confirmação do paciente.',
      hint: 'Reenvie o link para reduzir faltas. Lembretes automáticos entram em fila; o envio ao paciente ainda é operacional (WhatsApp/e-mail).',
      lastSent: 'Último envio: {when}',
      notSent: 'Ainda não enviado ao paciente'
    },
    onboarding: {
      steps: {
        welcome: 'Boas-vindas',
        clinic: 'Clínica',
        hours: 'Horários',
        team: 'Equipe',
        finish: 'Finalizar'
      },
      logout: 'Sair',
      back: 'Voltar',
      next: 'Continuar',
      start: 'Começar Configuração',
      finishCta: 'Finalizar',
      creating: 'Criando...',
      welcomeTitle: 'Bem-vindo ao ÁgilOdonto!',
      welcomeBody: 'Vamos configurar sua clínica em poucos passos para você começar a faturar.',
      illustrationAlt: 'Consultório odontológico',
      clinicTitle: 'Dados da clínica',
      clinicBody: 'Essas informações aparecem na agenda e nos convites da equipe.',
      name: 'Nome da clínica',
      namePlaceholder: 'Ex: OdontoMais',
      description: 'Descrição',
      descriptionPlaceholder: 'Descreva brevemente sua clínica',
      address: 'Endereço',
      addressPlaceholder: 'Rua, número, bairro e cidade',
      phone: 'Telefone',
      email: 'E-mail da clínica',
      cnpj: 'CNPJ',
      country: 'País/origem',
      countryHint: 'Brasil paga em real. Os outros países pagam em dólar.',
      summaryCountry: 'País/origem',
      requiredHint: 'Nome e descrição são obrigatórios.',
      hoursTitle: 'Horários de funcionamento',
      hoursBody: 'A grade da agenda usa esses horários como padrão da clínica.',
      teamTitle: 'Convide a equipe',
      teamBody: 'Opcional. Você pode adicionar profissionais e secretárias agora ou depois.',
      memberName: 'Nome',
      memberEmail: 'E-mail',
      role: 'Função',
      addMember: 'Adicionar',
      skipHint: 'No teste, a clínica fica com você como único profissional, sem secretária. Dá para ampliar a equipe depois de assinar.',
      remove: 'Remover',
      finishTitle: 'Tudo pronto para começar',
      finishBody: 'Confira os dados e crie a clínica. O período de teste começa agora.',
      summaryClinic: 'Clínica',
      summaryHours: 'Horários',
      summaryTeam: 'Equipe',
      noInvites: 'Nenhum convite',
      inviteCount: '{count} convite(s)',
      created: 'Clínica criada com sucesso!',
      createError: 'Erro ao criar clínica: {message}',
      inviteWarning: 'Clínica criada, mas algum convite não foi enviado.',
      logoutOk: 'Logout realizado com sucesso!',
      logoutError: 'Erro ao fazer logout',
      invalidMember: 'Informe nome e e-mail para adicionar alguém à equipe.'
    },
    landing: {
      navFeatures: 'Funcionalidades',
      navPricing: 'Preços',
      navBlog: 'Blog',
      navContact: 'Contato',
      login: 'Entrar',
      openMenu: 'Abrir menu',
      closeMenu: 'Fechar menu',
      beta: 'BETA',
      heroLead: 'Revolucione sua',
      heroHighlight: 'Clínica Odontológica',
      heroBody: 'A plataforma de gestão odontológica ágil, integrada e descomplicada. Tenha controle absoluto da sua agenda, prontuários e equipe em um só lugar.',
      heroCta: 'Começar Gratuitamente',
      previewTitle: 'Agenda do Dia',
      filters: 'Filtros',
      statusConfirmed: 'Confirmado',
      statusWaiting: 'Aguardando',
      featuresEyebrow: 'Recursos Completos',
      featuresTitle: 'Funcionalidades Poderosas',
      featuresBody: 'Tudo o que sua clínica precisa para operar com agilidade máxima e oferecer a melhor experiência ao paciente.',
      features: [
        { title: 'Agenda com disponibilidade', description: 'Visualização rápida de horários disponíveis e marcação ágil em poucos cliques, otimizando o fluxo diário.' },
        { title: 'Gestão de Equipe', description: 'Controle permissões de dentistas, recepcionistas e administradores de forma simples e independente.' },
        { title: 'Pacientes e anotações', description: 'Histórico completo de tratamentos, evolução clínica e arquivos centralizados de maneira segura.' },
        { title: 'Confirmação por link', description: 'Lembrete por e-mail com link de confirmação que atualiza a agenda. O reenvio por WhatsApp continua manual no painel.' },
        { title: 'Isolamento por clínica', description: 'Gerencie múltiplas unidades com total separação de dados e configurações financeiras independentes.' },
        { title: 'Tempo real', description: 'Acompanhe atualizações instantâneas de status dos pacientes na sala de espera ou nos consultórios.' }
      ],
      dailyTitle: 'Feito para o dia a dia da clínica',
      dailyBody: 'Foco no operacional, agenda firme, confirmação assistida e prontuário leve.',
      daily: [
        { title: 'Agenda operacional', description: 'Grade por profissional, divisão rápida por cores e bloqueio fácil de horários ou feriados.' },
        { title: 'Confirmação assistida', description: 'Lembretes integrados que garantem a presença do paciente e reduzem faltas em até 40%.' },
        { title: 'Prontuário simples', description: 'Acesso simplificado a anamnese, documentos e evolução odontológica sem poluição visual.' }
      ],
      pricingTitle: 'Planos que se adaptam ao seu negócio',
      pricingBody: 'Mensalidade por conta. Economia no plano anual (~2 meses grátis).',
      trialNote: '20 dias de teste full, sem cartão. Depois, o plano Free segue com agenda e prontuário básico.',
      compareTitle: 'Depois do trial: Free permanente ou upgrade',
      compareBody: '1 clínica · 1 profissional no Free. Pague só quando precisar do consultório completo.',
      compareFreeNote: 'Permanente após o trial de 20 dias',
      comparePaidNote: 'Tudo do Free + recursos clínicos pagos',
      comparePaidBadge: 'Recomendado para desbloquear',
      comparePaidCta: 'Fazer upgrade',
      compareFreeCta: 'Continuar no grátis',
      compareFoot: 'Planos Essencial / Clínica / Rede mantêm os limites atuais. O Free não altera os pagos.',
      monthly: 'Mensal',
      annual: 'Anual',
      popular: 'Mais Popular',
      perMonth: '/mês',
      annualNote: 'Cobrado anualmente · de {price}/mês no mensal',
      subscribe: 'Assinar Plano',
      freeTrial: 'Teste grátis',
      contactEyebrow: 'Fale Conosco',
      contactTitle: 'Entre em Contato',
      contactBody: 'Dúvidas sobre os planos, recursos personalizados ou migração de dados? Nossa equipe odontológica está à disposição.',
      formTitle: 'Envie uma mensagem',
      yourName: 'Seu Nome',
      namePlaceholder: 'Ex: Dra. Aline Hofmann',
      whatsapp: 'WhatsApp',
      sending: 'Enviando...',
      send: 'Enviar Mensagem',
      sent: 'Mensagem enviada. Vamos retornar pelo WhatsApp.',
      sendError: 'Não foi possível enviar a mensagem.',
      footerAbout: 'Simplificando a rotina e potencializando os consultórios e clínicas em todo o Brasil.',
      product: 'Produto',
      support: 'Suporte',
      terms: 'Termos de Uso',
      privacy: 'Política de Privacidade',
      rights: '© 2026 ÁgilOdonto. Todos os direitos reservados.',
      procedures: ['Avaliação Geral', 'Canal', 'Manutenção de Aparelho']
    },
    checkout: {
      back: 'Voltar',
      eyebrow: 'Assinatura AgilOdonto',
      planTitle: 'Plano {name}',
      card: 'Cartão',
      pix: 'Pix',
      billedAnnually: 'cobrado anualmente',
      pixNow: 'No Pix você paga {price} agora',
      months12: '(12 meses)',
      month1: '(1 mês)',
      adminOnly: 'Apenas o administrador da clínica pode assinar',
      noRedirect: 'Checkout criado sem URL de redirecionamento',
      payError: 'Não foi possível iniciar o pagamento',
      pixReady: 'Pix gerado. Escaneie o QR ou copie o código.',
      pixError: 'Não foi possível gerar o Pix',
      usdNotConfigured: 'O cartão em dólar ainda não está configurado neste ambiente.',
      stripeNotConfigured: 'Stripe (cartão/assinatura) está pronto no código, mas as credenciais de teste ainda não foram configuradas.',
      pixNotConfigured: 'OpenPix (Pix) está pronto no código. Crie a conta PJ, o AppID da API e o secret do webhook e envie para ligarmos o ambiente.',
      paymentUnavailable: 'Pagamento indisponível no momento.',
      alreadySubscribed: 'Esta clínica já tem uma assinatura ativa. Gerencie o plano em Configurações.',
      createAccount: 'Criar conta e assinar',
      haveAccount: 'Já tenho conta',
      setupClinic: 'Configurar clínica e continuar',
      goSettings: 'Ir para configurações',
      redirecting: 'Redirecionando...',
      payCard: 'Pagar com cartão (Stripe)',
      generatingPix: 'Gerando Pix...',
      generatePix: 'Gerar Pix (OpenPix)',
      cardNote: 'Cartão e assinatura recorrente pela Stripe.',
      cardTestHint: 'Teste: 4242 4242 4242 4242.',
      pixNote: 'Pix à vista pela OpenPix. A renovação gera um novo QR neste checkout.',
      coupon: 'Cupom',
      couponPlaceholder: 'Código do cupom',
      applyCoupon: 'Aplicar',
      applyingCoupon: 'Aplicando...',
      couponPriceSame: 'O valor continua {price}. O cupom só aumenta a vigência.',
      renewalWithoutCoupon: 'Renovação sem cupom: {date}',
      renewalWithCoupon: 'Renovação com cupom: {date}',
      monthsWithCoupon: '({months} meses)',
      couponReasons: {
        empty: 'Informe o código do cupom.',
        missing: 'Cupom não encontrado.',
        inactive: 'Cupom indisponível.',
        expired: 'Cupom expirado.',
        plan: 'Este cupom não vale para o plano escolhido.',
        cycle: 'Este cupom só vale no plano anual.',
        already_used: 'Este cupom já foi usado nesta clínica.',
        not_first_contract: 'O cupom vale só na primeira contratação anual.',
        invalid: 'Cupom inválido.'
      },
      otherPlans: 'Outros planos'
    },
    ...shellPages['pt-BR'],
    ...morePages['pt-BR'],
    legal: legalPt
  },
  en: {
    plans: plansEn,
    roles: {
      admin: 'Admin',
      secretary: 'Secretary',
      professional: 'Professional',
      super_admin: 'Super admin'
    },
    nav: {
      dashboard: 'Dashboard',
      appointments: 'Appointments',
      patients: 'Patients',
      myCalendar: 'My Calendar',
      generalCalendar: 'General Calendar',
      users: 'Users',
      settings: 'Settings',
      clinics: 'Manage Clinics',
      logout: 'Log out',
      openSidebar: 'Open sidebar',
      superAdmin: 'Super Admin mode',
      fullAccess: 'Full access to the system',
      setupTitle: 'Setup required',
      setupBody: 'You need to set up your clinic to continue.',
      setupCta: 'Set up now'
    },
    news: {
      title: 'News',
      subtitle: 'Tickets for your clinic, the product roadmap, and suggestions.',
      open: 'News',
      unread: 'New reply from support',
      back: 'Back',
      cancel: 'Cancel',
      tabs: {
        support: 'Tickets',
        roadmap: 'Roadmap',
        suggestions: 'Suggestions'
      },
      errors: {
        generic: 'Could not finish that. Try again.',
        'file-too-big': 'File is over 15 MB.',
        'file-type': 'Use an image, PDF, or MP4.',
        'too-many-files': 'Up to 4 files.',
        'empty-message': 'Write a message or attach a file.',
        'subject-required': 'Enter a subject.',
        'title-required': 'Enter a title.',
        'body-required': 'Describe the suggestion.',
        'missing-clinic': 'Select a clinic before opening a ticket.',
        'missing-ticket': 'Ticket not found.'
      },
      support: {
        new: 'New ticket',
        subject: 'Subject',
        message: 'Message',
        send: 'Send',
        reply: 'Reply',
        attach: 'Attach an image, PDF, or video',
        removeFile: 'Remove file',
        empty: 'No tickets yet.',
        emptyHint: 'Open a ticket to reach support. Only your clinic can see this conversation.',
        select: 'Select a ticket to read the thread.',
        search: 'Search tickets...',
        statusFilter: 'Status:',
        endOfList: 'No more tickets to show',
        olderMessages: 'Load earlier messages',
        noResults: 'No tickets found.',
        noResultsHint: 'Try another status or adjust your search.',
        customerLabel: 'Customer',
        supportTeam: 'AgilOdonto team',
        replyPlaceholder: 'Write your reply...',
        messagePlaceholder: 'Describe what is happening...',
        supportLabel: 'Support',
        changeStatus: 'Change status',
        created: 'Ticket opened.',
        sent: 'Message sent.',
        statusUpdated: 'Status updated.',
        loadError: 'Could not load tickets.',
        status: {
          all: 'All',
          open: 'Open',
          in_progress: 'In progress',
          waiting_customer: 'Waiting on you',
          waiting_customer_admin: 'Waiting on customer',
          resolved: 'Resolved'
        }
      },
      roadmap: {
        items: roadmapItemsEn,
        empty: 'Nothing on the roadmap yet.',
        emptyHint: 'Upcoming platform work shows up here.',
        new: 'New item',
        edit: 'Edit',
        titleField: 'Title',
        description: 'Description',
        statusLabel: 'Status',
        save: 'Publish',
        update: 'Save',
        archive: 'Archive',
        unarchive: 'Restore',
        showArchived: 'Show archived',
        archived: 'Archived',
        moveUp: 'Move up',
        moveDown: 'Move down',
        delete: 'Delete',
        confirmDelete: 'Delete this roadmap item?',
        created: 'Item published.',
        saved: 'Roadmap updated.',
        loadError: 'Could not load the roadmap.',
        status: {
          planned: 'Planned',
          in_progress: 'In progress',
          done: 'Done'
        }
      },
      suggestions: {
        empty: 'No suggestions yet.',
        emptyHint: 'Tell us what would make the platform better.',
        new: 'New suggestion',
        titleField: 'Title',
        body: 'Description',
        publish: 'Publish',
        likes: '{count} likes',
        comments: '{count} comments',
        commentPlaceholder: 'Write a comment',
        send: 'Send',
        noComments: 'No comments yet.',
        by: 'by {name}',
        changeStatus: 'Suggestion status',
        remove: 'Remove',
        confirmDelete: 'Remove this suggestion and its comments?',
        created: 'Suggestion published.',
        commented: 'Comment sent.',
        loadError: 'Could not load suggestions.',
        status: {
          open: 'Open',
          planned: 'Planned',
          done: 'Done',
          declined: 'Declined'
        }
      }
    },
    tester: {
      banner: 'Test account — free access to the platform, no subscription.',
      badge: 'Test account',
      toggle: 'Test account',
      toggleHint: 'Free access, no charge. The banner stays visible for the whole team.'
    },
    trial: {
      endsIn: 'Your trial ends in {count} days. Subscribe now so you don\'t lose your data.',
      endsInOne: 'Your trial ends in 1 day. Subscribe now so you don\'t lose your data.',
      ended: 'Your 20-day trial ended. You are on the Free plan: Schedule, Calendar and Patient (Overview + Media). Other features stay visible with a lock.',
      cta: 'Subscribe now'
    },
    upgrade: {
      title: 'Unlock your practice tools',
      body: 'On Free you keep Schedule, Calendar and Patient (Overview + Media). Upgrade for odontogram, HOF, Suggestions and the rest of the chart.',
      benefitOdontogram: 'Odontogram and HOF map',
      benefitTabs: 'Every patient tab',
      benefitSuggestions: 'Suggestions (NewsHub)',
      benefitLimits: 'Individual plan limits (1 clinic · 1 professional)',
      freeName: 'Free',
      freePrice: 'US$ 0',
      freePointSeats: '· 1 clinic · 1 pro',
      freePointAgenda: '· Schedule + Calendar',
      freePointPatient: '· Patient: overview + media',
      freePointLocks: '· Everything else locked',
      paidName: 'Individual',
      paidPrice: 'US$ 15/mo',
      paidPointSeats: '· 1 clinic · 1 pro',
      paidPointClinical: '· Odontogram + HOF',
      paidPointSuggestions: '· Suggestions + full tabs',
      paidPointStorage: '· 500 MB of media',
      cta: 'Upgrade',
      stayFree: 'Stay on Free',
      orStayFree: 'or stay on Free',
      seePlans: 'See plans',
      askAdmin: 'Ask the clinic admin to subscribe to Individual.',
      close: 'Close',
      cardTitle: 'Unlock the full practice',
      cardPrice: 'Individual from US$15/mo',
      afterTrialBadge: 'After trial · Free active',
      suggestionsTitle: 'Suggestions is paid',
      suggestionsBody: 'On the Free plan this module stays locked. Upgrade to Individual (US$15/mo) or higher and pick up where you left off.',
      patientTabLocked: {
        odontograma: 'On the Free plan the odontogram stays locked. Upgrade to record this patient’s dental history.',
        hof: 'On the Free plan the HOF map stays locked. Upgrade to mark regions, procedures and the before and after.',
        ortodontia: 'On the Free plan orthodontics stays locked. Upgrade to follow this patient’s treatment.',
        default: 'This part of the chart stays locked on the Free plan. Upgrade to continue.'
      }
    },
    weekdays: {
      sunday: 'Sunday',
      monday: 'Monday',
      tuesday: 'Tuesday',
      wednesday: 'Wednesday',
      thursday: 'Thursday',
      friday: 'Friday',
      saturday: 'Saturday'
    },
    hours: {
      title: 'Office hours',
      hint: 'Sets the slots available on the schedule',
      until: 'to',
      break: 'Break',
      to: 'to'
    },
    dashboard: {
      title: 'Dashboard',
      myTitle: 'My Dashboard',
      subtitle: 'Clinic overview',
      mySubtitle: 'Overview of your appointments',
      date: 'Date:',
      today: 'Today',
      all: 'View all',
      total: 'Total appointments',
      mine: 'My appointments',
      confirmed: 'Confirmed',
      pending: 'Pending',
      cancelled: 'Cancelled',
      noShow: 'No-shows',
      appointmentsOf: 'Appointments on {date}',
      myAppointments: 'My appointments',
      allSuffix: ' — All',
      emptyToday: 'No appointments for today',
      emptyMine: 'You have no appointments today',
      emptyAll: 'No appointments found',
      noClinicTitle: 'No clinic selected',
      noClinicBody: 'Select a clinic to continue.',
      loadError: 'Could not load dashboard data',
      needClinic: 'Set up your clinic first',
      professional: 'Professional',
      statusConfirmed: 'Confirmed',
      statusPending: 'Pending',
      statusCancelled: 'Cancelled',
      statusNoShow: 'No-show',
      statusCompleted: 'Completed',
      professionals: 'Active professionals',
      adminSuffix: '(Admin)'
    },
    pending: {
      title: 'Pending confirmations',
      onTrack: 'Up to date',
      empty: 'No upcoming appointment is waiting for the patient to confirm.',
      hint: 'Resend the link to reduce no-shows. Automatic reminders are queued; delivery to the patient is still operational (WhatsApp/email).',
      lastSent: 'Last sent: {when}',
      notSent: 'Not sent to the patient yet'
    },
    onboarding: {
      steps: {
        welcome: 'Welcome',
        clinic: 'Clinic',
        hours: 'Hours',
        team: 'Team',
        finish: 'Finish'
      },
      logout: 'Log out',
      back: 'Back',
      next: 'Continue',
      start: 'Start setup',
      finishCta: 'Finish',
      creating: 'Creating...',
      welcomeTitle: 'Welcome to ÁgilOdonto!',
      welcomeBody: 'Let\'s set up your clinic in a few steps so you can start billing.',
      illustrationAlt: 'Dental office',
      clinicTitle: 'Clinic details',
      clinicBody: 'This information shows up on the schedule and team invites.',
      name: 'Clinic name',
      namePlaceholder: 'E.g. OdontoMais',
      description: 'Description',
      descriptionPlaceholder: 'Briefly describe your clinic',
      address: 'Address',
      addressPlaceholder: 'Street, number, neighborhood and city',
      phone: 'Phone',
      email: 'Clinic email',
      cnpj: 'Tax ID',
      country: 'Country of origin',
      countryHint: 'Brazil is billed in reais. Every other country is billed in US dollars.',
      summaryCountry: 'Country of origin',
      requiredHint: 'Name and description are required.',
      hoursTitle: 'Office hours',
      hoursBody: 'The schedule uses these hours as the clinic default.',
      teamTitle: 'Invite your team',
      teamBody: 'Optional. Add professionals and secretaries now or later.',
      memberName: 'Name',
      memberEmail: 'Email',
      role: 'Role',
      addMember: 'Add',
      skipHint: 'During the trial the clinic stays with you as the only professional, with no secretary. You can grow the team after you subscribe.',
      remove: 'Remove',
      finishTitle: 'Ready to start',
      finishBody: 'Review the details and create the clinic. Your trial starts now.',
      summaryClinic: 'Clinic',
      summaryHours: 'Hours',
      summaryTeam: 'Team',
      noInvites: 'No invites',
      inviteCount: '{count} invite(s)',
      created: 'Clinic created successfully!',
      createError: 'Could not create the clinic: {message}',
      inviteWarning: 'Clinic created, but an invite could not be sent.',
      logoutOk: 'Signed out successfully!',
      logoutError: 'Could not sign out',
      invalidMember: 'Enter a name and email to add someone to the team.'
    },
    landing: {
      navFeatures: 'Features',
      navPricing: 'Pricing',
      navBlog: 'Blog',
      navContact: 'Contact',
      login: 'Log in',
      openMenu: 'Open menu',
      closeMenu: 'Close menu',
      beta: 'BETA',
      heroLead: 'Transform your',
      heroHighlight: 'Dental Clinic',
      heroBody: 'An agile, integrated dental practice platform. Keep your schedule, records and team in one place.',
      heroCta: 'Start for free',
      previewTitle: 'Today\'s schedule',
      filters: 'Filters',
      statusConfirmed: 'Confirmed',
      statusWaiting: 'Waiting',
      featuresEyebrow: 'Complete toolkit',
      featuresTitle: 'Powerful features',
      featuresBody: 'Everything your clinic needs to run quickly and give patients a better experience.',
      features: [
        { title: 'Availability-based schedule', description: 'See open slots quickly and book in a few clicks, keeping the day moving.' },
        { title: 'Team management', description: 'Set permissions for dentists, receptionists and admins independently.' },
        { title: 'Patients and notes', description: 'Treatment history, clinical progress and files kept together and secure.' },
        { title: 'Confirmation links', description: 'Email reminders with a confirmation link that updates the schedule. WhatsApp resend stays manual in the panel.' },
        { title: 'Clinic isolation', description: 'Run multiple locations with fully separated data and settings.' },
        { title: 'Real time', description: 'Follow patient status updates instantly in the waiting room or operatories.' }
      ],
      dailyTitle: 'Built for the clinic day',
      dailyBody: 'Operational focus, a firm schedule, assisted confirmation and a light chart.',
      daily: [
        { title: 'Operational schedule', description: 'A grid per professional, color coding and easy blocks for time off or holidays.' },
        { title: 'Assisted confirmation', description: 'Reminders that help patients show up and cut no-shows by up to 40%.' },
        { title: 'Simple chart', description: 'Anamnesis, documents and dental progress without visual clutter.' }
      ],
      pricingTitle: 'Plans that fit your practice',
      pricingBody: 'Monthly price per clinic. Save on the annual plan (~2 months free).',
      trialNote: '20-day full trial, no card. After that, Free keeps the schedule and a basic chart.',
      compareTitle: 'After the trial: permanent Free or upgrade',
      compareBody: '1 clinic · 1 professional on Free. Pay only when you need the full practice.',
      compareFreeNote: 'Permanent after the 20-day trial',
      comparePaidNote: 'Everything in Free + paid clinical tools',
      comparePaidBadge: 'Recommended to unlock',
      comparePaidCta: 'Upgrade',
      compareFreeCta: 'Stay on Free',
      compareFoot: 'Essential / Clinic / Network keep their current limits. Free does not change paid plans.',
      monthly: 'Monthly',
      annual: 'Annual',
      popular: 'Most popular',
      perMonth: '/mo',
      annualNote: 'Billed annually · was {price}/mo monthly',
      subscribe: 'Subscribe',
      freeTrial: 'Free trial',
      contactEyebrow: 'Talk to us',
      contactTitle: 'Get in touch',
      contactBody: 'Questions about plans, custom features or data migration? Our dental team is here.',
      formTitle: 'Send a message',
      yourName: 'Your name',
      namePlaceholder: 'E.g. Dra. Aline Hofmann',
      whatsapp: 'WhatsApp',
      sending: 'Sending...',
      send: 'Send message',
      sent: 'Message sent. We will reply on WhatsApp.',
      sendError: 'Could not send the message.',
      footerAbout: 'Simplifying the routine and strengthening dental practices across Brazil.',
      product: 'Product',
      support: 'Support',
      terms: 'Terms of use',
      privacy: 'Privacy policy',
      rights: '© 2026 ÁgilOdonto. All rights reserved.',
      procedures: ['General exam', 'Root canal', 'Appliance maintenance']
    },
    checkout: {
      back: 'Back',
      eyebrow: 'AgilOdonto subscription',
      planTitle: '{name} plan',
      card: 'Card',
      pix: 'Pix',
      billedAnnually: 'billed annually',
      pixNow: 'With Pix you pay {price} now',
      months12: '(12 months)',
      month1: '(1 month)',
      adminOnly: 'Only the clinic administrator can subscribe',
      noRedirect: 'Checkout was created without a redirect URL',
      payError: 'Could not start the payment',
      pixReady: 'Pix generated. Scan the QR code or copy the code.',
      pixError: 'Could not generate the Pix charge',
      usdNotConfigured: 'Card checkout in US dollars is not configured in this environment yet.',
      stripeNotConfigured: 'Card checkout is ready in the code, but the test credentials are not configured yet.',
      pixNotConfigured: 'Pix is ready in the code. Add the business account, API App ID and webhook secret to turn it on.',
      paymentUnavailable: 'Payment is unavailable right now.',
      alreadySubscribed: 'This clinic already has an active subscription. Manage the plan in Settings.',
      createAccount: 'Create an account and subscribe',
      haveAccount: 'I already have an account',
      setupClinic: 'Set up the clinic and continue',
      goSettings: 'Go to settings',
      redirecting: 'Redirecting...',
      payCard: 'Pay by card (Stripe)',
      generatingPix: 'Generating Pix...',
      generatePix: 'Generate Pix (OpenPix)',
      cardNote: 'Recurring card subscription through Stripe.',
      cardTestHint: 'Test card: 4242 4242 4242 4242.',
      pixNote: 'One-time Pix through OpenPix. Renewal creates a new QR code on this checkout.',
      coupon: 'Coupon',
      couponPlaceholder: 'Coupon code',
      applyCoupon: 'Apply',
      applyingCoupon: 'Applying...',
      couponPriceSame: 'The price stays {price}. The coupon only extends the term.',
      renewalWithoutCoupon: 'Renewal without coupon: {date}',
      renewalWithCoupon: 'Renewal with coupon: {date}',
      monthsWithCoupon: '({months} months)',
      couponReasons: {
        empty: 'Enter the coupon code.',
        missing: 'Coupon not found.',
        inactive: 'Coupon unavailable.',
        expired: 'Coupon expired.',
        plan: 'This coupon does not apply to the selected plan.',
        cycle: 'This coupon is only valid on the annual plan.',
        already_used: 'This coupon was already used by this clinic.',
        not_first_contract: 'The coupon applies only to the first annual subscription.',
        invalid: 'Invalid coupon.'
      },
      otherPlans: 'Other plans'
    },
    ...shellPages.en,
    ...morePages.en,
    legal: legalEn
  },
  es: {
    plans: plansEs,
    roles: {
      admin: 'Admin',
      secretary: 'Secretaria',
      professional: 'Profesional',
      super_admin: 'Super admin'
    },
    nav: {
      dashboard: 'Panel',
      appointments: 'Citas',
      patients: 'Pacientes',
      myCalendar: 'Mi calendario',
      generalCalendar: 'Calendario general',
      users: 'Usuarios',
      settings: 'Configuración',
      clinics: 'Gestionar clínicas',
      logout: 'Salir',
      openSidebar: 'Abrir menú',
      superAdmin: 'Modo super admin',
      fullAccess: 'Acceso completo al sistema',
      setupTitle: 'Configuración necesaria',
      setupBody: 'Necesitas configurar tu clínica para continuar.',
      setupCta: 'Configurar ahora'
    },
    news: {
      title: 'Novedades',
      subtitle: 'Tickets de tu clínica, el roadmap y las sugerencias de la plataforma.',
      open: 'Novedades',
      unread: 'Hay una respuesta nueva del soporte',
      back: 'Volver',
      cancel: 'Cancelar',
      tabs: {
        support: 'Tickets',
        roadmap: 'Roadmap',
        suggestions: 'Sugerencias'
      },
      errors: {
        generic: 'No se pudo completar. Inténtalo de nuevo.',
        'file-too-big': 'El archivo supera 15 MB.',
        'file-type': 'Usa una imagen, PDF o MP4.',
        'too-many-files': 'Máximo 4 archivos.',
        'empty-message': 'Escribe un mensaje o adjunta un archivo.',
        'subject-required': 'Indica el asunto.',
        'title-required': 'Indica el título.',
        'body-required': 'Describe la sugerencia.',
        'missing-clinic': 'Selecciona una clínica para abrir el ticket.',
        'missing-ticket': 'Ticket no encontrado.'
      },
      support: {
        new: 'Nuevo ticket',
        subject: 'Asunto',
        message: 'Mensaje',
        send: 'Enviar',
        reply: 'Responder',
        attach: 'Adjuntar imagen, PDF o video',
        removeFile: 'Quitar archivo',
        empty: 'Todavía no hay tickets.',
        emptyHint: 'Abre un ticket para hablar con soporte. Solo tu clínica ve esta conversación.',
        select: 'Selecciona un ticket para ver la conversación.',
        search: 'Buscar tickets...',
        statusFilter: 'Estado:',
        endOfList: 'No hay más tickets para mostrar',
        olderMessages: 'Cargar mensajes anteriores',
        noResults: 'No se encontraron tickets.',
        noResultsHint: 'Prueba otro estado o ajusta la búsqueda.',
        customerLabel: 'Cliente',
        supportTeam: 'Equipo AgilOdonto',
        replyPlaceholder: 'Escribe tu respuesta...',
        messagePlaceholder: 'Describe lo que está pasando...',
        supportLabel: 'Soporte',
        changeStatus: 'Cambiar estado',
        created: 'Ticket abierto.',
        sent: 'Mensaje enviado.',
        statusUpdated: 'Estado actualizado.',
        loadError: 'No se pudieron cargar los tickets.',
        status: {
          all: 'Todos',
          open: 'Abierto',
          in_progress: 'En curso',
          waiting_customer: 'Esperando tu respuesta',
          waiting_customer_admin: 'Esperando al cliente',
          resolved: 'Resuelto'
        }
      },
      roadmap: {
        items: roadmapItemsEs,
        empty: 'Todavía no hay nada en el roadmap.',
        emptyHint: 'Los próximos pasos de la plataforma aparecen aquí.',
        new: 'Nuevo ítem',
        edit: 'Editar',
        titleField: 'Título',
        description: 'Descripción',
        statusLabel: 'Estado',
        save: 'Publicar',
        update: 'Guardar',
        archive: 'Archivar',
        unarchive: 'Restaurar',
        showArchived: 'Mostrar archivados',
        archived: 'Archivado',
        moveUp: 'Subir',
        moveDown: 'Bajar',
        delete: 'Eliminar',
        confirmDelete: '¿Eliminar este ítem del roadmap?',
        created: 'Ítem publicado.',
        saved: 'Roadmap actualizado.',
        loadError: 'No se pudo cargar el roadmap.',
        status: {
          planned: 'Planeado',
          in_progress: 'En curso',
          done: 'Hecho'
        }
      },
      suggestions: {
        empty: 'Todavía no hay sugerencias.',
        emptyHint: 'Cuéntanos qué mejoraría la plataforma.',
        new: 'Nueva sugerencia',
        titleField: 'Título',
        body: 'Descripción',
        publish: 'Publicar',
        likes: '{count} me gusta',
        comments: '{count} comentarios',
        commentPlaceholder: 'Escribe un comentario',
        send: 'Enviar',
        noComments: 'Todavía no hay comentarios.',
        by: 'por {name}',
        changeStatus: 'Estado de la sugerencia',
        remove: 'Quitar',
        confirmDelete: '¿Quitar esta sugerencia y sus comentarios?',
        created: 'Sugerencia publicada.',
        commented: 'Comentario enviado.',
        loadError: 'No se pudieron cargar las sugerencias.',
        status: {
          open: 'Abierta',
          planned: 'Planeada',
          done: 'Hecha',
          declined: 'Rechazada'
        }
      }
    },
    tester: {
      banner: 'Cuenta de prueba — acceso libre a la plataforma, sin suscripción.',
      badge: 'Cuenta de prueba',
      toggle: 'Cuenta de prueba',
      toggleHint: 'Acceso libre, sin cobro. El aviso queda visible para todo el equipo.'
    },
    trial: {
      endsIn: 'Tu período de prueba termina en {count} días. Suscríbete ahora y no pierdas tus datos.',
      endsInOne: 'Tu período de prueba termina en 1 día. Suscríbete ahora y no pierdas tus datos.',
      ended: 'Tu prueba de 20 días terminó. Estás en el plan Free: Agenda, Calendario y Paciente (Visión general + Medios). El resto queda visible con candado.',
      cta: 'Suscribirse ahora'
    },
    upgrade: {
      title: 'Desbloquea las herramientas del consultorio',
      body: 'En Free mantienes Agenda, Calendario y Paciente (Visión general + Medios). Haz upgrade para odontograma, HOF, Sugerencias y el resto de la ficha.',
      benefitOdontogram: 'Odontograma y mapa HOF',
      benefitTabs: 'Todas las pestañas del paciente',
      benefitSuggestions: 'Sugerencias (NewsHub)',
      benefitLimits: 'Límites del plan Individual (1 clínica · 1 profesional)',
      freeName: 'Free',
      freePrice: 'US$ 0',
      freePointSeats: '· 1 clínica · 1 prof.',
      freePointAgenda: '· Agenda + Calendario',
      freePointPatient: '· Paciente: visión + medios',
      freePointLocks: '· El resto con candado',
      paidName: 'Individual',
      paidPrice: 'US$ 15/mes',
      paidPointSeats: '· 1 clínica · 1 prof.',
      paidPointClinical: '· Odontograma + HOF',
      paidPointSuggestions: '· Sugerencias + pestañas completas',
      paidPointStorage: '· 500 MB de medios',
      cta: 'Hacer upgrade',
      stayFree: 'Seguir en gratis',
      orStayFree: 'o seguir en gratis',
      seePlans: 'Ver planes',
      askAdmin: 'Pide al admin de la clínica que contrate Individual.',
      close: 'Cerrar',
      cardTitle: 'Desbloquea el consultorio completo',
      cardPrice: 'Individual desde US$15/mes',
      afterTrialBadge: 'Tras la prueba · Free activo',
      suggestionsTitle: 'Sugerencias es de pago',
      suggestionsBody: 'En el plan Free este módulo queda bloqueado. Haz upgrade a Individual (US$15/mes) o superior y continúa donde lo dejaste.',
      patientTabLocked: {
        odontograma: 'En el plan Free el odontograma queda bloqueado. Haz upgrade para registrar el historial dental de este paciente.',
        hof: 'En el plan Free el mapa HOF queda bloqueado. Haz upgrade para marcar regiones, procedimientos y el antes y después.',
        ortodontia: 'En el plan Free la ortodoncia queda bloqueada. Haz upgrade para seguir el tratamiento de este paciente.',
        default: 'Esta parte de la ficha queda bloqueada en el plan Free. Haz upgrade para continuar.'
      }
    },
    weekdays: {
      sunday: 'Domingo',
      monday: 'Lunes',
      tuesday: 'Martes',
      wednesday: 'Miércoles',
      thursday: 'Jueves',
      friday: 'Viernes',
      saturday: 'Sábado'
    },
    hours: {
      title: 'Horarios de atención',
      hint: 'Define la grilla disponible en la agenda',
      until: 'a',
      break: 'Intervalo',
      to: 'a'
    },
    dashboard: {
      title: 'Panel',
      myTitle: 'Mi panel',
      subtitle: 'Resumen de la clínica',
      mySubtitle: 'Resumen de tus citas',
      date: 'Fecha:',
      today: 'Ver hoy',
      all: 'Ver todas',
      total: 'Total de citas',
      mine: 'Mis citas',
      confirmed: 'Confirmadas',
      pending: 'Pendientes',
      cancelled: 'Canceladas',
      noShow: 'No asistieron',
      appointmentsOf: 'Citas del {date}',
      myAppointments: 'Mis citas',
      allSuffix: ' — Todas',
      emptyToday: 'Ninguna cita para hoy',
      emptyMine: 'No tienes citas para hoy',
      emptyAll: 'No se encontraron citas',
      noClinicTitle: 'Ninguna clínica seleccionada',
      noClinicBody: 'Selecciona una clínica para continuar.',
      loadError: 'No se pudieron cargar los datos del panel',
      needClinic: 'Primero configura tu clínica',
      professional: 'Profesional',
      statusConfirmed: 'Confirmada',
      statusPending: 'Pendiente',
      statusCancelled: 'Cancelada',
      statusNoShow: 'No asistió',
      statusCompleted: 'Completada',
      professionals: 'Profesionales activos',
      adminSuffix: '(Admin)'
    },
    pending: {
      title: 'Confirmaciones pendientes',
      onTrack: 'Al día',
      empty: 'Ninguna cita futura espera la confirmación del paciente.',
      hint: 'Reenvíe el enlace para reducir ausencias. Los recordatorios automáticos entran en cola; el envío al paciente sigue siendo operativo (WhatsApp/correo).',
      lastSent: 'Último envío: {when}',
      notSent: 'Aún no se envió al paciente'
    },
    onboarding: {
      steps: {
        welcome: 'Bienvenida',
        clinic: 'Clínica',
        hours: 'Horarios',
        team: 'Equipo',
        finish: 'Finalizar'
      },
      logout: 'Salir',
      back: 'Volver',
      next: 'Continuar',
      start: 'Empezar configuración',
      finishCta: 'Finalizar',
      creating: 'Creando...',
      welcomeTitle: '¡Bienvenido a ÁgilOdonto!',
      welcomeBody: 'Vamos a configurar tu clínica en pocos pasos para que empieces a facturar.',
      illustrationAlt: 'Consultorio odontológico',
      clinicTitle: 'Datos de la clínica',
      clinicBody: 'Esta información aparece en la agenda y en las invitaciones del equipo.',
      name: 'Nombre de la clínica',
      namePlaceholder: 'Ej: OdontoMais',
      description: 'Descripción',
      descriptionPlaceholder: 'Describe brevemente tu clínica',
      address: 'Dirección',
      addressPlaceholder: 'Calle, número, barrio y ciudad',
      phone: 'Teléfono',
      email: 'Correo de la clínica',
      cnpj: 'CNPJ',
      country: 'País/origen',
      countryHint: 'Brasil paga en reales. Los demás países pagan en dólares.',
      summaryCountry: 'País/origen',
      requiredHint: 'El nombre y la descripción son obligatorios.',
      hoursTitle: 'Horarios de atención',
      hoursBody: 'La agenda usa estos horarios como estándar de la clínica.',
      teamTitle: 'Invita al equipo',
      teamBody: 'Opcional. Puedes agregar profesionales y secretarias ahora o después.',
      memberName: 'Nombre',
      memberEmail: 'Correo',
      role: 'Función',
      addMember: 'Agregar',
      skipHint: 'En la prueba la clínica queda contigo como único profesional, sin secretaria. Puedes ampliar el equipo después de suscribirte.',
      remove: 'Quitar',
      finishTitle: 'Todo listo para empezar',
      finishBody: 'Revisa los datos y crea la clínica. El período de prueba empieza ahora.',
      summaryClinic: 'Clínica',
      summaryHours: 'Horarios',
      summaryTeam: 'Equipo',
      noInvites: 'Ninguna invitación',
      inviteCount: '{count} invitación(es)',
      created: '¡Clínica creada con éxito!',
      createError: 'Error al crear la clínica: {message}',
      inviteWarning: 'Clínica creada, pero alguna invitación no se envió.',
      logoutOk: 'Sesión cerrada con éxito.',
      logoutError: 'No se pudo cerrar la sesión',
      invalidMember: 'Indica nombre y correo para agregar a alguien al equipo.'
    },
    landing: {
      navFeatures: 'Funciones',
      navPricing: 'Precios',
      navBlog: 'Blog',
      navContact: 'Contacto',
      login: 'Entrar',
      openMenu: 'Abrir menú',
      closeMenu: 'Cerrar menú',
      beta: 'BETA',
      heroLead: 'Revoluciona tu',
      heroHighlight: 'Clínica Odontológica',
      heroBody: 'La plataforma de gestión odontológica ágil, integrada y simple. Controla agenda, historiales y equipo en un solo lugar.',
      heroCta: 'Empezar gratis',
      previewTitle: 'Agenda del día',
      filters: 'Filtros',
      statusConfirmed: 'Confirmado',
      statusWaiting: 'En espera',
      featuresEyebrow: 'Recursos completos',
      featuresTitle: 'Funciones potentes',
      featuresBody: 'Todo lo que tu clínica necesita para operar con agilidad y ofrecer una mejor experiencia al paciente.',
      features: [
        { title: 'Agenda con disponibilidad', description: 'Ve horarios libres rápido y agenda en pocos clics, optimizando el día.' },
        { title: 'Gestión del equipo', description: 'Controla permisos de dentistas, recepcionistas y administradores de forma independiente.' },
        { title: 'Pacientes y notas', description: 'Historial de tratamientos, evolución clínica y archivos centralizados de forma segura.' },
        { title: 'Confirmación por enlace', description: 'Recordatorio por e-mail con un enlace que actualiza la agenda. El reenvío por WhatsApp sigue manual en el panel.' },
        { title: 'Aislamiento por clínica', description: 'Gestiona varias sedes con datos y configuraciones totalmente separados.' },
        { title: 'Tiempo real', description: 'Sigue el estado de los pacientes al instante en la sala de espera o los consultorios.' }
      ],
      dailyTitle: 'Hecho para el día a día de la clínica',
      dailyBody: 'Foco operativo, agenda firme, confirmación asistida e historia clínica ligera.',
      daily: [
        { title: 'Agenda operativa', description: 'Grilla por profesional, colores y bloqueo fácil de horarios o feriados.' },
        { title: 'Confirmación asistida', description: 'Recordatorios que ayudan a la asistencia y reducen faltas hasta un 40%.' },
        { title: 'Historia simple', description: 'Anamnesis, documentos y evolución odontológica sin ruido visual.' }
      ],
      pricingTitle: 'Planes que se adaptan a tu negocio',
      pricingBody: 'Mensualidad por clínica. Ahorro en el plan anual (~2 meses gratis).',
      trialNote: '20 días de prueba completa, sin tarjeta. Después, Free sigue con agenda e historia básica.',
      compareTitle: 'Después de la prueba: Free permanente o upgrade',
      compareBody: '1 clínica · 1 profesional en Free. Paga solo cuando necesites el consultorio completo.',
      compareFreeNote: 'Permanente después de la prueba de 20 días',
      comparePaidNote: 'Todo lo de Free + herramientas clínicas de pago',
      comparePaidBadge: 'Recomendado para desbloquear',
      comparePaidCta: 'Hacer upgrade',
      compareFreeCta: 'Seguir en gratis',
      compareFoot: 'Esencial / Clínica / Red mantienen sus límites. Free no cambia los planes de pago.',
      monthly: 'Mensual',
      annual: 'Anual',
      popular: 'Más popular',
      perMonth: '/mes',
      annualNote: 'Cobro anual · de {price}/mes en el mensual',
      subscribe: 'Suscribirse',
      freeTrial: 'Prueba gratis',
      contactEyebrow: 'Hablemos',
      contactTitle: 'Contacto',
      contactBody: '¿Dudas sobre planes, recursos personalizados o migración de datos? Nuestro equipo odontológico está disponible.',
      formTitle: 'Envía un mensaje',
      yourName: 'Tu nombre',
      namePlaceholder: 'Ej: Dra. Aline Hofmann',
      whatsapp: 'WhatsApp',
      sending: 'Enviando...',
      send: 'Enviar mensaje',
      sent: 'Mensaje enviado. Responderemos por WhatsApp.',
      sendError: 'No se pudo enviar el mensaje.',
      footerAbout: 'Simplificando la rutina y potenciando consultorios y clínicas en todo Brasil.',
      product: 'Producto',
      support: 'Soporte',
      terms: 'Términos de uso',
      privacy: 'Política de privacidad',
      rights: '© 2026 ÁgilOdonto. Todos los derechos reservados.',
      procedures: ['Evaluación general', 'Endodoncia', 'Mantenimiento de aparato']
    },
    checkout: {
      back: 'Volver',
      eyebrow: 'Suscripción AgilOdonto',
      planTitle: 'Plan {name}',
      card: 'Tarjeta',
      pix: 'Pix',
      billedAnnually: 'cobro anual',
      pixNow: 'Con Pix pagas {price} ahora',
      months12: '(12 meses)',
      month1: '(1 mes)',
      adminOnly: 'Solo el administrador de la clínica puede suscribirse',
      noRedirect: 'El checkout se creó sin una URL de redirección',
      payError: 'No se pudo iniciar el pago',
      pixReady: 'Pix generado. Escanea el QR o copia el código.',
      pixError: 'No se pudo generar el Pix',
      usdNotConfigured: 'El pago con tarjeta en dólares todavía no está configurado en este entorno.',
      stripeNotConfigured: 'El pago con tarjeta está listo en el código, pero las credenciales de prueba aún no están configuradas.',
      pixNotConfigured: 'Pix está listo en el código. Agrega la cuenta, el App ID de la API y el secreto del webhook para activarlo.',
      paymentUnavailable: 'El pago no está disponible en este momento.',
      alreadySubscribed: 'Esta clínica ya tiene una suscripción activa. Gestiona el plan en Configuración.',
      createAccount: 'Crear cuenta y suscribirse',
      haveAccount: 'Ya tengo cuenta',
      setupClinic: 'Configurar la clínica y continuar',
      goSettings: 'Ir a configuración',
      redirecting: 'Redirigiendo...',
      payCard: 'Pagar con tarjeta (Stripe)',
      generatingPix: 'Generando Pix...',
      generatePix: 'Generar Pix (OpenPix)',
      cardNote: 'Suscripción recurrente con tarjeta por Stripe.',
      cardTestHint: 'Prueba: 4242 4242 4242 4242.',
      pixNote: 'Pix al contado por OpenPix. La renovación genera un nuevo QR en este checkout.',
      coupon: 'Cupón',
      couponPlaceholder: 'Código del cupón',
      applyCoupon: 'Aplicar',
      applyingCoupon: 'Aplicando...',
      couponPriceSame: 'El valor sigue siendo {price}. El cupón solo alarga la vigencia.',
      renewalWithoutCoupon: 'Renovación sin cupón: {date}',
      renewalWithCoupon: 'Renovación con cupón: {date}',
      monthsWithCoupon: '({months} meses)',
      couponReasons: {
        empty: 'Indica el código del cupón.',
        missing: 'Cupón no encontrado.',
        inactive: 'Cupón no disponible.',
        expired: 'Cupón vencido.',
        plan: 'Este cupón no vale para el plan elegido.',
        cycle: 'Este cupón solo vale en el plan anual.',
        already_used: 'Este cupón ya se usó en esta clínica.',
        not_first_contract: 'El cupón vale solo en la primera contratación anual.',
        invalid: 'Cupón inválido.'
      },
      otherPlans: 'Otros planes'
    },
    ...shellPages.es,
    ...morePages.es,
    legal: legalEs
  }
};
